"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
var Alert = function (props) {
    var children = props.children, classes = props.classes, action = props.action, closeText = props.closeText, color = props.color, severity = props.severity, icon = props.icon, role = props.role, iconMapping = props.iconMapping, onClose = props.onClose, variant = props.variant;
    return (react_1.default.createElement(Alert_1.default, { classes: classes, action: action, closeText: closeText, color: color, severity: severity, icon: icon, role: role, iconMapping: iconMapping, onClose: onClose, variant: variant }, children));
};
exports.default = Alert;
